export default "__VITE_ASSET__BINv5xbU__"